import { LabelValue } from "@shared/models/label-value.interface";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { classNames } from "primereact/utils";

interface SimpleDropdownProps {
  value: string,
  name: string,
  label: string,
  options: Array<LabelValue>,
  onChange: (event: DropdownChangeEvent) => void
  className?: string
}
export default function SimpleDropdown({value, name, label, className, options, onChange}: SimpleDropdownProps) {
  return (
      <span className={classNames("p-float-label", className)}>
        <Dropdown
          value={value}
          name={name}
          options={options}
          onChange={(e) => {
            onChange(e);
          }}
          className="w-full"
        />

        <label className="text-xs text-gray-500" htmlFor={name}>
          {label}
        </label>
      </span>
  );
}
